export default "__VITE_ASSET__CLEEjKFs__"